import React from "react";
import { observer } from "mobx-react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { getCurrentCulture } from "@utils";
import MyBetsViewStore from "@state/stores/my-bets/MyBetsViewStore";
import { MultiItem, SingleItem, SkeletonLoader } from ".";
import { MyBetsAutosellConfirmation } from "@features/my-bets/desktop/common/autosell-confirmation";
import { CashoutConfirmation } from "@features/my-bets/desktop/common/cashout";
import MyBetsReuseConfirmation from "@features/my-bets/desktop/common/MyBetsReuseConfirmation";
import ShareBetSlipModal from "@features/my-bets/desktop/common/ShareBetSlipModal";
import { quickFilterOptions } from "@features/my-bets/shared/QuickFilterOptions";

const BetListDisplayAuthUser = observer(function BetListDisplayAuthUser(props: {
	myBetsViewStore: MyBetsViewStore;
}) {
	const { t } = useTranslation("mybets");

	const isFull =
		getCurrentCulture() == "de" ||
		getCurrentCulture() == "fr" ||
		getCurrentCulture() == "hr" ||
		getCurrentCulture() == "it";

	if (props.myBetsViewStore.isLoading) {
		return <SkeletonLoader />;
	}

	return (
		<React.Fragment>
			<div className="tabs--primary tabs--primary--bordered">
				{quickFilterOptions.map((option) => (
					<a
						className={classNames("tabs--primary__item", {
							"is-active":
								option ===
								props.myBetsViewStore.filterOptionType,
						})}
						onClick={() =>
							props.myBetsViewStore.filterMiniBets(option)
						}
						key={option}
					>
						{t<string>("FILTER_OPTION.OPTION_" + option)}
					</a>
				))}
			</div>
			<div
				className={classNames("widget__body", {
					"widget--bets__body": !props.myBetsViewStore.isEmpty,
					"widget--bets__empty": props.myBetsViewStore.isEmpty,
				})}
			>
				{props.myBetsViewStore.isEmpty ? (
					<>
						<i className="u-icon u-icon--huge u-icon--empty--bets u-mar--bottom--xsml" />
						<div className="u-type--center">
							{t<string>("EMPTY")}
						</div>
					</>
				) : (
					<>
						{props.myBetsViewStore.bets.map((bet) => {
							if (bet.betSlipOffers.length === 1) {
								return (
									<SingleItem
										key={bet.id}
										bet={bet}
										isFull={isFull}
										myBetsViewStore={props.myBetsViewStore}
									/>
								);
							} else {
								return (
									<MultiItem
										key={bet.id}
										bet={bet}
										isFull={isFull}
										myBetsViewStore={props.myBetsViewStore}
									/>
								);
							}
						})}
					</>
				)}
			</div>
			<CashoutConfirmation
				isOpen={props.myBetsViewStore.cashoutStore.isCashoutModalOpen}
				cashoutModalData={
					props.myBetsViewStore.cashoutStore.cashoutModalData
				}
				onAccept={props.myBetsViewStore.cashoutStore.cashout}
				onClose={props.myBetsViewStore.cashoutStore.closeCashoutModal}
				isSubmitting={
					props.myBetsViewStore.cashoutStore.isCashoutFormSubmitting
				}
			/>
			<MyBetsReuseConfirmationModal
				myBetsViewStore={props.myBetsViewStore}
			/>
			<MyBetsAutosellConfirmation
				store={props.myBetsViewStore.cashoutStore}
			/>
			<ShareBetSlipModal />
		</React.Fragment>
	);
});

const MyBetsReuseConfirmationModal = observer(
	function MyBetsReuseConfirmationModal(props: {
		myBetsViewStore: MyBetsViewStore;
	}) {
		if (!props.myBetsViewStore.isReuseModalOpen) {
			return null;
		}

		return (
			<MyBetsReuseConfirmation
				isOpen={props.myBetsViewStore.isReuseModalOpen}
				{...props.myBetsViewStore.reuseModalData}
				onAccept={props.myBetsViewStore.reuseBetSlip}
				onClose={props.myBetsViewStore.closeReuseBetSlipModal}
			/>
		);
	}
);

export default BetListDisplayAuthUser;
